import React from 'react';
import Navbar from './Navbar';
import './IntroPage.css';       // for navbar styling
import './MissionVision.css';   // for mission/vision styles

const MissionVision = () => (
  <>
    <Navbar />

    <div className="intro-container">
      <section className="mission">
        <h2>Mission Statement</h2>
        <p>
        To empower students in India through the education of implementable, sustainable practices and innovative means of learning through the aid of volunteers aiming to create a better world. 
        </p>
      </section>

      <section className="vision">
        <h2>Vision</h2>
        <p>
        We’re building a future where young people don’t just learn. 
        They implement their attained knowledge in their desired fields. 
        Our goal is to inspire children across India to become bold leaders who question, advocate, and create change. 
        Outside of just their desired field of interest, we aim for students to become strong environmental advocates. Because this climate crisis isn’t a distant threat for India— it’s a brutal reality. 
        By giving the next generation of students a strong set of tools, we are helping them shape a better reality for themselves and their country. 
        <br></br>
        We educate and empower students through the promotion of three principal values.
        </p>
        <ul>
          <li><strong>Integrity:</strong> While we aim to establish strong environmental advocates among the next generation of India, we also recognize the importance of having a sense of integrity. It is important that we foster passionate students who act with honesty throughout their fields. </li>
          <li><strong>Innovation:</strong> Ensuring quality education is available to every child, regardless of their geographical or socio-economic background.</li>
          <li><strong>Accessibility:</strong> Leveraging technology and creative teaching methods to engage and educate children about environmental issues.</li>
        </ul>
        <p>
          This approach emphasizes the importance of equipping young minds with the tools 
          and understanding needed to tackle environmental challenges while ensuring that 
          the educational experience is both inclusive and forward-thinking.
        </p>
      </section>
    </div>
  </>
);

export default MissionVision;
